import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import {
  ExpensesFilterForm,
  ExpensesFilterFormPaginated,
  ExpensesFilterFormValues,
} from 'features/expenses-report/component/expenses-filter-form';
import { ExpensesTable } from 'features/expenses-report/component/expenses-table/expenses-table';
import { EditReportExpensesModal } from 'features/expenses-report/component/modal/details/editReport';
import { ExpensesReportViewModal } from 'features/expenses-report/component/modal/expenses-modal';
import { useGetExpenses } from 'features/expenses-report/use-cases/get-fields';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
const { useBreakpoint } = Grid;
const initialFilterValues: ExpensesFilterFormValues = {
  FieldId: undefined,
  FacilityId: undefined,
  SportsId: undefined,
};

export const ExpensesReportView = () => {
  const screens = useBreakpoint();
  const { params, updateParams, resetPage } =
    usePaginationParams<ExpensesFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });

  const { data, isFetching, refetch } = useGetExpenses(params, {
    retry: false,
  });
  const [Modal, setModal] = useState(false);
  const [EditModal, setEditModal] = useState(false);
  const [editdata, setEditdata] = useState('');

  const handleFiltersChange = (values: ExpensesFilterFormValues) => {
    updateParams(values);
    resetPage();
    refetch();
  };
  const formId = 'fields-filters-form';

  return (
    <>
      <ContentTopBar
        title={'Expenses Charge'}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => setModal(true)}
            >
              Add Expenses Charge
            </Button>
          </>
        }
      />
      {Modal && (
        <ExpensesReportViewModal
          onClose={() => setModal(false)}
          editdata={null}
        />
      )}
      {EditModal && (
        <EditReportExpensesModal
          onClose={() => setEditModal(false)}
          editdata={editdata}
        />
      )}

      <ContentFilters formId={formId}>
        <ExpensesFilterForm
          formId={formId}
          handleFilter={handleFiltersChange}
          initialValues={initialFilterValues}
        />
      </ContentFilters>

      <ExpensesTable
        data={data}
        isLoading={isFetching}
        tableParams={params}
        updateParams={updateParams}
        setEditModal={setEditModal}
        setEditdata={setEditdata}
      />
      <Outlet />
    </>
  );
};
